import { useTranslation } from '@/features/i18n';
import { Button } from '@/ui/buttons/Button';
import { AssetType } from '@vimond/services/content-discovery';
import { PlaylistItem } from './PlaylistItem';

type Props = {
  countdown: number;
  onUserCancelCountdown: () => void;
  nextAsset?: AssetType;
  onClick?: (id: string) => void;
};
export const PlaylistCountdown = ({
  countdown,
  nextAsset,
  onClick,
  onUserCancelCountdown,
}: Props) => {
  const { t } = useTranslation();
  if (!nextAsset) return null;
  const w = Math.max(0, Math.min(100, ((countdown - 1) / 10) * 100)).toFixed(2);
  return (
    <div className="text-shadow absolute z-10 flex items-center justify-center max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:top-0 max-md:h-screen max-md:w-full md:bottom-4 md:right-4">
      <div className="m-auto flex w-[300px] flex-col items-center gap-1 rounded-lg bg-black bg-opacity-70 p-2 overflow-hidden box-border">
        <span className="text-button-primary-text">
          {t('starting-next-video-in-x-seconds', { count: countdown })}
        </span>
        <div
          className={`bg-button-primary-background rounded-md py-1 transition-all duration-1000 ease-linear`}
          style={{ width: `${w}%` }}
        ></div>
        <PlaylistItem
          asset={nextAsset}
          active
          onClick={() => {
            onClick?.(nextAsset.id);
          }}
        />
        <Button variant="text" size="xs" onClick={onUserCancelCountdown}>
          {t('cancel-autoplay')}
        </Button>
      </div>
    </div>
  );
};
